/**
 * <currency-selector-component>
 * Wraps a Shopify localization form whose <select> lists the store's available
 * currencies. Changing the select submits the form so the storefront switches
 * currency (currency is bound to country/market in Shopify Markets).
 */
class CurrencySelector extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('select');
    this.form = this.querySelector('form');
    if (!this.select || !this.form) return;
    this.select.addEventListener('change', this.handleChange);
  }

  disconnectedCallback() {
    this.select?.removeEventListener('change', this.handleChange);
  }

  handleChange = () => {
    if (this.form.requestSubmit) {
      this.form.requestSubmit();
    } else {
      this.form.submit();
    }
  };
}

if (!customElements.get('currency-selector-component')) {
  customElements.define('currency-selector-component', CurrencySelector);
}
